module.exports = __webpack_public_path__ + "assets/images/icons/action_platform_icon.cf4586e144a2ceaf466d802f9e12a79e.svg";